var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"summary-item"},[_c('span',{staticClass:"has-text-weight-bold",class:{ 'has-text-warning': _vm.showWarning },domProps:{"innerHTML":_vm._s(_vm.label + ':')}}),_vm._v(" "+_vm._s(_vm.item.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }